// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


/* custom-events.js — robust renderer for variant ingredient text */
(function () {
  function getContainer() {
    return document.getElementById('variant-ingredient');
  }

  function getMap() {
    const c = getContainer();
    if (!c) return null;
    const json = c.getAttribute('data-ingredients');
    if (!json) return null;
    try { return JSON.parse(json); } catch { return null; }
  }

  // Turn any value (string | array | object | null) into a displayable string
  function normalizeText(val) {
    if (val == null) return '';
    if (typeof val === 'string') return val;

    // If it's an array (e.g., "list of multi-line text"), join with blank lines
    if (Array.isArray(val)) {
      return val.map(normalizeText).filter(Boolean).join('\n\n');
    }

    // If it's an object, try common shapes; otherwise JSON-stringify as a last resort
    if (typeof val === 'object') {
      // Shopify metafields sometimes surface { value: "..." }
      if (typeof val.value === 'string') return val.value;
      if (Array.isArray(val.value)) return normalizeText(val.value);
      if (typeof val.text === 'string') return val.text;
      try { return JSON.stringify(val); } catch { return ''; }
    }

    // Numbers/booleans/etc.
    return String(val);
  }

  function toHtmlWithLineBreaks(s) {
    return normalizeText(s).replace(/\n/g, '<br>');
  }

  function getCurrentVariantId() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    const input = form.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function render(variantId) {
    const c = getContainer();
    if (!c) return;
    const map = getMap();
    if (!map) return;
    const raw = map[String(variantId)];
    c.innerHTML = toHtmlWithLineBreaks(raw);
  }

  function onVariantChange(e) {
    const id =
      e?.detail?.variant?.id ||
      e?.detail?.variantId ||
      e?.detail?.id ||
      getCurrentVariantId();
    if (!id) return;
    // Defer so other listeners (even if they throw) don’t block our update
    requestAnimationFrame(() => render(String(id)));
  }

  function init() {
    const id = getCurrentVariantId();
    if (id) render(String(id));
  }

  // Listen for common theme/app events
  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('product:variant-change', onVariantChange);
  document.addEventListener('theme:variant:change', onVariantChange);

  // Fallback: direct change on variant input/select
  document.addEventListener('change', function (e) {
    const t = e.target;
    if (t && (t.name === 'id' || t.matches?.('select[name="id"]'))) {
      const id = getCurrentVariantId();
      if (id) requestAnimationFrame(() => render(String(id)));
    }
  }, true);

  // Re-init on section lifecycle
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);

  // Initial render
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
